import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file_deauflt",
  "use": "icon-file_deauflt-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-file_deauflt\">\r\n<title>file_deauflt</title>\r\n<path fill=\"#8d8d8d\" d=\"M4.573 3.61h22.873c0.506 0 0.99 0.201 1.348 0.558s0.558 0.842 0.558 1.348v1.906h-26.685v-1.906c0-0.506 0.201-0.99 0.558-1.348s0.842-0.558 1.348-0.558v0zM2.667 9.329v17.155c0 0.506 0.201 0.99 0.558 1.348s0.842 0.558 1.348 0.558h22.873c0.506 0 0.99-0.201 1.348-0.558s0.558-0.842 0.558-1.348v-17.155h-26.685zM21.728 13.141h-11.437v-1.906h11.437v1.906z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/file_deauflt.svg
// module id = OmKK
// module chunks = 14